module.exports = __webpack_public_path__ + "img/office-space-manager-get-to-the-point.aeb66237.webp";